import { t } from '../locales/translate.js';

// Swedish number format with two decimals: space as thousands separator, decimal comma
export const formatNumber = (value) =>
  Number(value).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatKr = (amount) => `${formatNumber(amount)} kr`;

// Older backends only send price_per_kg; the price_* breakdown fields are missing entirely
export const hasPriceBreakdown = (report) => 'price_mode' in report;

// null means the viewer may not see the price
export const priceTotal = (report) => {
  if (hasPriceBreakdown(report)) {
    return report.price_total ?? null;
  }
  return report.price_per_kg ? report.weight * report.price_per_kg : null;
};

// How the total was calculated, e.g. "10,00 kg × 12,00 kr/kg"; null when there is nothing to explain
export const priceExplanation = (report) => {
  if (!hasPriceBreakdown(report)) {
    return report.price_per_kg ? `${formatNumber(report.price_per_kg)} kr/kg` : null;
  }
  switch (report.price_mode) {
    case 'kg':
      return `${formatNumber(report.price_units)} kg × ${formatNumber(report.price_unit_price)} kr/kg`;
    case 'unit':
      return `${t('price_unit_prefix')}: ${report.price_units ?? 1} st × ${formatNumber(report.price_unit_price)} kr`;
    case 'below_min':
      return t('price_below_min');
    default:
      return null;
  }
};

// Transport compensation is already part of price_total, so it is only shown as "varav ..."
export const priceTransportation = (report) => {
  const amount = Number(report.price_transportation_total);
  return amount > 0 ? `${t('price_transport_included')} ${formatKr(amount)}` : null;
};
